import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba7599d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"color":"#c8c9cc","font-size":"14px","line-height":"24px"}
}
const _hoisted_6 = { class: "default-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "footer xag-page__footer"
}
const _hoisted_8 = { class: "content" }

import AppHeader from '@/components/Header.vue'
import FormItemWrap from './components/form-item-wrap.vue'
import getRoute from '@/compositions/route'
import { reactive, computed, ComputedRef, ref, Ref } from 'vue'
import { useRouter, Router } from 'vue-router'
import { AreaItem, saveAddressParams, userAddressItem } from '@/types/invoice'
import { getAreaInfo, saveUserAddressInfo } from '@/apis/invoice'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  addressListStorageKey,
  addressEditItemStorageKey,
} from './definition'
import { Button, Field, Checkbox, Popup, Cascader, Toast } from 'vant'
import {
  showConfirmModal,
  debouce,
  showToastLoading,
  clearToast,
  showToastFail,
  showToastSuccess,
} from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'address-edit',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const components = {
  AppHeader,
  FormItemWrap,
  Field,
}
const { query: routerQuery } = getRoute()
const showFooter = ref(false)
let guid = (routerQuery.value.guid as string) || ''
let cacheData: userAddressItem = {} as userAddressItem
if (guid) {
  const storageStr = sessionStorage.getItem(addressEditItemStorageKey)
  if (storageStr) {
    cacheData = JSON.parse(storageStr)
  } else {
    cacheData = {} as userAddressItem
  }
}
const $router: Router = useRouter()
const isEdit = !!routerQuery.value.guid
const pageTitle = `${isEdit ? '编辑' : '新增'}地址`
const areaIdMap: { [props: number]: AreaItem } = {}
const form = reactive({
  name: cacheData.name || '',
  phone: cacheData.phone || '',
  area_address: cacheData.area_address || '',
  area: {
    name: cacheData.area_name || '',
    id: cacheData.area_id || '',
  },
  default: cacheData.default || false,
})

const showPopup: Ref<boolean> = ref(false)
const cascaderValue: Ref<string> = ref('')
const areaOptions: Ref<AreaItem[]> = ref([])
const fieldNames = {
  text: 'name',
  value: 'id',
  children: 'children',
}
async function cascaderChange(params) {
  let value = params.value
  let selectedOptions = params.selectedOptions
  let currentItem = areaIdMap[value]
  if (currentItem && currentItem.children && currentItem.children.length === 0) {
    showToastLoading()
    try {
      let data = await getAreaInfoHandle(value)
      if (data && data.length) {
        currentItem.children = data
        currentItem.children.forEach((item: AreaItem) => {
          areaIdMap[item.id] = item
        })
      } else {
        setTimeout(() => {
          delete currentItem.children
        }, 100)
        cascaderFinish({ selectedOptions })
      }
    } catch (error) {
      console.log('error', error)
    }
    clearToast()
  }
}
function cascaderFinish({ selectedOptions }) {
  showPopup.value = false
  form.area.name = selectedOptions.map((item: AreaItem) => item.name).join('/')
  form.area.id = cascaderValue.value
}
async function getAreaInfoHandle(upid = 0) {
  try {
    let data = await getAreaInfo({ upid })
    let result = data.map((item: AreaItem) => {
      let result = {
        ...item,
        children: item.children || [],
      }
      return result
    })
    return result
  } catch (error) {
    let message = (error && error.message) || '获取地址失败'
    showToastFail(message)
  }
  return []
}
async function initAreaInfo() {
  try {
    let data = await getAreaInfoHandle()
    areaOptions.value = data
    areaOptions.value.forEach((item: AreaItem) => {
      areaIdMap[item.id] = item
    })
    // if (!isEdit && !form.area.name) {
    //   form.area.name = data[0].name
    // }
  } catch (e) {
    console.log('e', e)
  }
}
function getSaveParameter() {
  // 获取参数
  const parameter: saveAddressParams = {
    name: form.name,
    phone: form.phone,
    area_address: form.area_address,
    area: form.area,
    default: form.default ? 'true' : 'false',
    guid,
  }

  return parameter
}
function verifyParameter(parameter: saveAddressParams) {
  let message = ''
  if (!parameter.name) {
    message = '请输入联系人名称'
  } else if (!parameter.phone) {
    message = '请输入联系人手机号码'
  } else if (!parameter.area.id) {
    message = '请选择地区'
  } else if (!parameter.area_address) {
    message = '请输入详细地址'
  }
  if (message) {
    Toast(message)
    return false
  }
  return true
}
async function saveInvoiceHandle() {
  const parameter = getSaveParameter()
  if (!verifyParameter(parameter)) {
    return
  }
  try {
    await showConfirmModal({
      title: '是否确认保存？',
    })
    showToastLoading()
    await saveUserAddressInfo(parameter)
    sessionStorage.removeItem(addressListStorageKey)
    showToastSuccess('保存成功')
    $router.go(-1)
  } catch (e) {
    if (!e) {
      return
    }
    let message = e && e.message
    showToastFail(message)
  }
}
initAreaInfo()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: pageTitle }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FormItemWrap, {
          label: "联系人",
          require: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Field), {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
              class: "input-class",
              placeholder: "名字"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormItemWrap, {
          label: "手机号码",
          require: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Field), {
              modelValue: form.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.phone) = $event)),
              class: "input-class",
              placeholder: "手机号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormItemWrap, {
          label: "地区",
          require: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "area-wrap",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPopup.value = true))
            }, [
              (form.area.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(form.area.name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "地区信息")),
              _createVNode(_component_van_icon, {
                name: "arrow",
                class: "arrow-item"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(FormItemWrap, {
          label: "详细地址",
          require: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Field), {
              modelValue: form.area_address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.area_address) = $event)),
              class: "input-class",
              placeholder: "街道门牌信息"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(Popup), {
        show: showPopup.value,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showPopup).value = $event)),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Cascader), {
            modelValue: cascaderValue.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cascaderValue).value = $event)),
            title: "请选择地区",
            "active-color": "#00B359",
            "field-names": fieldNames,
            options: areaOptions.value,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (showPopup.value = false)),
            onChange: cascaderChange,
            onFinish: cascaderFinish
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Checkbox), {
          modelValue: form.default,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.default) = $event)),
          shape: "square",
          "icon-size": "16px",
          "checked-color": "#00B359"
        }, {
          default: _withCtx(() => [
            _createTextVNode("设为默认")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (!showPopup.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Button), {
              block: "",
              class: "confirm-button",
              onClick: saveInvoiceHandle
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})